import CalendarItemNotificationPayload from 'owa-service/lib/contract/CalendarItemNotificationPayload';
import CalendarItemTypeType from 'owa-service/lib/contract/CalendarItemTypeType';

/**
 * Constants for the notification types we process
 */
const NotificationTypeConstants = {
    RowAdded: 'RowAdded',
    RowModified: 'RowModified',
    RowDeleted: 'RowDeleted',
    Reload: 'Reload',
};

/**
 * CalendarItemNotificationPayload extended definition.
 */
export default class CalendarItemNotificationPayloadExtended {
    /**
     * The original notification payload
     */
    NotificationPayload: CalendarItemNotificationPayload;

    /**
     * This is set if we have an extra instance key to delete besides the one carried by the notification.
     */
    InstanceKeyToDelete: string;

    constructor(notification: CalendarItemNotificationPayload) {
        this.NotificationPayload = notification;
        this.InstanceKeyToDelete = null;
    }

    /**
     * Checks whether this is a RowModified notification
     */
    isRowModifiedNotification(): boolean {
        return this.NotificationPayload.EventType === NotificationTypeConstants.RowModified;
    }

    /**
     * Checks whether this is a RowDeleted notification
     */
    isRowDeletedNotification(): boolean {
        return this.NotificationPayload.EventType === NotificationTypeConstants.RowDeleted;
    }

    /**
     * Checks whether this is a RowAdded notification
     */
    isRowAddedNotification(): boolean {
        return this.NotificationPayload.EventType === NotificationTypeConstants.RowAdded;
    }

    /**
     * Checks whether this is a reload notification
     */
    isReloadNotification(): boolean {
        return (
            this.NotificationPayload.EventType === NotificationTypeConstants.Reload ||
            this.NotificationPayload.Reload
        );
    }

    /**
     * Checks if the item is of type RecurringMaster
     */
    isRecurringMaster(): boolean {
        const itemType: CalendarItemTypeType = this.NotificationPayload.Item.CalendarItemType;
        return !!itemType && itemType === 'RecurringMaster';
    }
}
